/**
 * Shifts API Module
 * CCH Care — Phase 2
 *
 * Path: src/api/shifts.js
 */
import client from './client';

export async function getCurrentShift() {
  const response = await client.get('/shifts/current.php');
  return response.data;
}

export async function getShiftSummary(careShiftId, shiftAssignmentId) {
  const response = await client.get('/shifts/summary.php', {
    params: { care_shift_id: careShiftId, shift_assignment_id: shiftAssignmentId }
  });
  return response.data;
}

export async function getHandoffNotes(careShiftId) {
  const response = await client.get('/shifts/handoff-notes.php', {
    params: { care_shift_id: careShiftId }
  });
  return response.data;
}

export async function createHandoffNote(note) {
  const response = await client.post('/shifts/handoff-notes.php', note);
  return response.data;
}